import { Button } from "@kamae-apps/shared/Components/Atoms/Button/Button"
import { NewsBar } from "@kamae-apps/shared/Components/Molecules/NewsBar/NewsBar"
import { useIsPageScrolling } from "@kamae-apps/shared/Hooks/useIsPageScrolling"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { useMatch, useNavigate } from "react-router-dom"
import { SidebarMode, useSidebarMode } from "../../Contexts/SidebarMode/SidebarModeContext"

export const NewsBarHandler: FC = () => {
  const { t } = useTranslation("app")
  const { isPageScrolling } = useIsPageScrolling()
  const { mode } = useSidebarMode()
  const isPhishingCreate = useMatch("/phishing/create") !== null
  const navigate = useNavigate()
  if (isPhishingCreate) return null

  return (
    <div
      className={mode !== SidebarMode.MOBILE ? "mx-3 mt-3" : "mx-4 mt-3"}
      style={{
        transform: isPageScrolling ? "translateY(-100%)" : "translateY(0)",
        transition: "transform 0.3s ease-out",
        position: "relative",
      }}
    >
      <NewsBar
        title={t("app:newsBarModal.title")}
        primaryButton={
          <Button
            variant="button-secondary-glass-small"
            onClick={() => navigate("/tatami#special-events")}
          >
            {t("app:newsBarModal.primaryButton")}
          </Button>
        }
        background="linear-gradient(90deg, #02285A 25%, #3A69A6 50%, #02285A 75%)"
        fullWidth
      />
    </div>
  )
}
